<template>
	<div class="container-mobile animated fadeIn">
		<div class="form content-contact-mobile">
			<b-row v-if="isFilmSingle && !isFilmSingleFree" class="mb-3">
				<b-col>
					<div class="float-right">
						<b-button variant="light" @click="handleClickAddProject">
							{{ FormMSG(21, 'Add project') }}
							<plus-circle color="#06263E" :size="16" />
						</b-button>
					</div>
				</b-col>
			</b-row>
			<b-row v-if="isFilmSingle && isFilmSingleFree" class="mb-3">
				<b-col>
					<div class="float-right">
						<subscription-dialog variantBtn="light" icon="fa fa-plus" :btn-label="FormMSG(21, 'Add project')" />
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col class="cols-12">
					<b-input-group>
						<b-form-input type="text" v-model="filter" :placeholder="FormMSG(1, 'Type to search ...')" @input="handleInputFilter" />
						<b-input-group-append>
							<b-input-group-text>
								<search color="#06263E" :size="16" class="icon" v-if="filter.length === 0" />
								<x color="#06263E" :size="16" class="icon" @click="clearFilter" v-else />
							</b-input-group-text>
						</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col>
					<div class="title-list">
						<h2>{{ title }}</h2>
					</div>
				</b-col>
			</b-row>
			<div v-if="listProjects.length === 0" class="text-center">
				<p>{{ FormMSG(3, 'No result') }}</p>
			</div>
			<div v-for="(project, index) in listProjects" :key="index" class="project-item" :class="{ active: myProject && myProject.id === project.id }">
				<div class="project-item-content-start" @click.prevent.stop="clickRow(project)">
					<p class="name-contact mb-0">
						<strong>{{ project.titre }}</strong>
					</p>
				</div>
				<div class="project-item-content-end">
					<div v-if="project.id === myProject.id">
						<b-button
							v-if="canEditProject"
							variant="light"
							class="mr-2"
							:class="{
								'mb-2': $screen.width <= 334,
								'float-right': !canEditProject
							}"
							@click="handleClickEdit"
						>
							<Edit color="#06263E" :size="16" />
						</b-button>
						<b-button variant="light" @click="handleClickCopy(project)">
							<clipboard-copy color="#06263E" :size="16" />
						</b-button>
					</div>
					<div v-if="isProduction && myProject && myProject.id !== project.id" class="project-group-checkbox-mobile">
						<div class="checkbox-item">
							<b-form-checkbox
								:id="`project-${project.id}`"
								size="lg"
								class="project-checkbox ml-3"
								switch
								v-model="myProjects[index].isVisible"
								v-tooltip.left="
									myProjects[index].isVisible
										? FormMSG(104, 'Hide this project from users. It will no longer be visible in the project list')
										: FormMSG(105, 'Make this project visible to users. It will appear in the project list.')
								"
								@click.stop
								@change="(value) => handleChangeCheck(value, index)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import { Search, XCircle, ClipboardCopy, Edit, PlusCircle, X } from 'lucide-vue';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import { store } from '@/store';
import GlobalMixin from '@/mixins/global.mixin';
import SubscriptionDialog from '@/components/InfoSheet/SubscriptionDialog.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'ListProjectMobile',

	components: {
		Search,
		XCircle,
		ClipboardCopy,
		Edit,
		PlusCircle,
		SubscriptionDialog,
		X
	},

	mixins: [languageMessages, isSingleProjectMixin, GlobalMixin],

	data() {
		return {
			filter: '',
			listProjects: [],
			originalListProjects: []
		};
	},

	computed: {
		...mapGetters({
			isProduction: 'config/isProduction',
			myProject: 'config/myProject',
			myProjects: 'config/myProjects'
		}),
		canEditProject() {
			if (store.isFilmSingleUserFree() || store.isFilmSingleUser()) {
				return true;
			} else {
				return false;
			}
		},
		title() {
			if (store.isPme()) {
				return this.FormMSG(110, 'Offices');
			}
			return this.FormMSG(10, 'Projects');
		}
	},

	watch: {
		myProjects: {
			handler(val) {
				this.listProjects = val;
				this.originalListProjects = val;
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		handleChangeCheck(value, index) {
			this.$emit('handle-change-check', value, index);
		},
		handleInputFilter(payload) {
			const filter = payload.trim().toLowerCase();
			this.listProjects = this.originalListProjects.filter((oLP) => {
				if (oLP.titre.toLowerCase().indexOf(filter) > -1) {
					return true;
				}
				return false;
			});
		},
		handleClickAddProject() {
			this.$emit('list-project-mobile:add-project');
		},
		async handleClickCopy(project) {
			const action = async () => {
				this.$emit('list-project-mobile:copy-invoice', project.invoiceDetails);
				this.createToastForMobile(this.FormMSG(22, 'invoice details copied successfully'), '', '');
			};
			this.confirmModal(action, this.FormMSG(23, 'Copy invoice details to clipboard ?'));
		},
		handleClickEdit() {
			this.$emit('list-project-mobile:edit-project');
		},
		clickRow(project) {
			this.$emit('list-project-mobile:change-project', project);
		},
		clearFilter() {
			if (this.filter !== '') {
				this.filter = '';
				this.listProjects = this.myProjects;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.project-item {
	display: flex;
	flex-direction: row;
	padding: 0.75rem 1.25rem;
	margin-bottom: -1px;
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.125);
	width: 100%;
	gap: 0.5rem;
	&:hover {
		background-color: hsl(206, 96%, 90%);
		cursor: pointer;
	}
	&.active {
		color: #fff;
		background-color: #00a09c;
		border-color: #00a09c;
		strong {
			color: #fff;
		}
	}
	&-content-start {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex: 1;
		gap: 0.5rem;
		cursor: pointer;
	}
	&-content-end {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		gap: 0.5rem;
	}
}

.project-group-checkbox-mobile {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem 0rem;
	border-radius: 0.5rem;
	transition: border-color 0.2s ease, box-shadow 0.2s ease;
	&:hover {
		border-color: #d1d5db;
	}

	&:focus-within {
		border-color: #0d6efd;
		box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);
	}
}
</style>
